/**
 * Shared helpers for email attachments on the Nylas
 * send-message flow.
 */

/**
 * formatAttachmentBytes returns a human-readable file size string, e.g.
 * "1.2 MB". Sizes below 1 MB are shown in KB, and below 1 KB in bytes, so that
 * a small file does not read as "0 KB".
 */
export const formatAttachmentBytes = (bytes: number): string => {
  if (bytes >= 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }
  if (bytes >= 1024) {
    return `${(bytes / 1024).toFixed(0)} KB`;
  }
  return `${bytes} B`;
};
